import { render, staticRenderFns } from "./ToggleFreeInputMethodEditor.vue?vue&type=template&id=5721abc9&scoped=true&"
import script from "./ToggleFreeInputMethodEditor.vue?vue&type=script&lang=ts&"
export * from "./ToggleFreeInputMethodEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5721abc9",
  null
  
)

export default component.exports